import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const CompanyCredentials = () => {
  const credentials = [
  {
    icon: 'Award',
    title: 'Experiencia Comprobada',
    description: '15+ años desarrollando proyectos inmobiliarios en Arequipa'
  },
  {
    icon: 'Users',
    title: 'Familias Satisfechas',
    description: 'Más de 2,500 familias confían en nuestros desarrollos'
  },
  {
    icon: 'Building2',
    title: 'Proyectos Entregados',
    description: '12 proyectos completados exitosamente en la región'
  },
  {
    icon: 'Shield',
    title: 'Garantía Total',
    description: 'Respaldo legal y financiero en todos nuestros proyectos'
  }];


  const testimonials = [
  {
    id: 1,
    name: 'María González',
    role: 'Propietaria en Residencial 3 Volcanes',
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_162a57531-1763296100992.png",
    avatarAlt: 'Professional headshot of Hispanic woman with long dark hair wearing elegant white blouse',
    content: 'Excelente inversión. La calidad de construcción y la ubicación superaron nuestras expectativas. El proceso de compra fue transparente y profesional.',
    rating: 5
  },
  {
    id: 2,
    name: 'Carlos Mendoza',
    role: 'Inversionista',
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_103972665-1763296698542.png",
    avatarAlt: 'Professional headshot of Hispanic man with short black hair wearing navy blue suit',
    content: 'Millennials es sinónimo de confianza en Arequipa. He invertido en tres de sus proyectos y todos han sido exitosos. Recomiendo ampliamente.',
    rating: 5
  }];


  return (
    <div className="space-y-6 md:space-y-8">
      <div className="card">
        <div className="flex items-center mb-6">
          <div className="w-12 h-12 md:w-16 md:h-16 bg-primary rounded-xl flex items-center justify-center mr-4">
            <Icon name="Mountain" size={32} color="var(--color-primary-foreground)" />
          </div>
          <div>
            <h2 className="text-2xl md:text-3xl font-semibold text-foreground">
              Millennials
            </h2>
            <p className="text-sm md:text-base text-muted-foreground">
              Desarrolladora Inmobiliaria
            </p>
          </div>
        </div>

        <p className="text-base md:text-lg text-foreground mb-6 leading-relaxed">
          Somos una empresa arequipeña con más de 15 años de experiencia en el desarrollo de proyectos inmobiliarios de alta calidad. Nuestro compromiso es crear espacios que mejoren la calidad de vida de las familias peruanas.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {credentials?.map((credential, index) =>
          <div
            key={index}
            className="bg-muted rounded-lg p-4 md:p-6 transition-smooth hover:bg-accent/10">

              <div className="flex items-start">
                <div className="w-10 h-10 md:w-12 md:h-12 bg-primary/10 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                  <Icon name={credential?.icon} size={24} color="var(--color-primary)" />
                </div>
                <div>
                  <h4 className="text-base md:text-lg font-semibold text-foreground mb-1">
                    {credential?.title}
                  </h4>
                  <p className="text-sm md:text-base text-muted-foreground">
                    {credential?.description}
                  </p>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      <div className="card">
        <h3 className="text-xl md:text-2xl font-semibold text-foreground mb-6">
          Testimonios de Clientes
        </h3>

        <div className="space-y-6">
          {testimonials?.map((testimonial) =>
          <div
            key={testimonial?.id}
            className="bg-muted rounded-lg p-4 md:p-6">

              <div className="flex items-start mb-4">
                <div className="w-12 h-12 md:w-16 md:h-16 rounded-full overflow-hidden mr-4 flex-shrink-0">
                  <Image
                  src={testimonial?.avatar}
                  alt={testimonial?.avatarAlt}
                  className="w-full h-full object-cover" />

                </div>
                <div className="flex-1">
                  <h4 className="text-base md:text-lg font-semibold text-foreground">
                    {testimonial?.name}
                  </h4>
                  <p className="text-sm text-muted-foreground mb-2">
                    {testimonial?.role}
                  </p>
                  <div className="flex items-center">
                    {[...Array(testimonial?.rating)]?.map((_, i) =>
                  <Icon
                    key={i}
                    name="Star"
                    size={16}
                    color="var(--color-warning)"
                    className="fill-current" />

                  )}
                  </div>
                </div>
              </div>
              <p className="text-sm md:text-base text-foreground leading-relaxed">
                "{testimonial?.content}"
              </p>
            </div>
          )}
        </div>
      </div>
      <div className="card bg-primary text-primary-foreground">
        <div className="flex items-center justify-between flex-wrap gap-4">
          <div>
            <h3 className="text-xl md:text-2xl font-semibold mb-2">
              ¿Listo para invertir?
            </h3>
            <p className="text-sm md:text-base opacity-90">
              Contáctanos y descubre las oportunidades disponibles
            </p>
          </div>
          <div className="flex items-center space-x-4">
            <a
              href="tel:+51054123456"
              className="flex items-center text-primary-foreground hover:opacity-80 transition-smooth">

              <Icon name="Phone" size={20} className="mr-2" />
              <span className="text-sm md:text-base font-medium whitespace-nowrap">
                (054) 12-3456
              </span>
            </a>
            <a
              href="mailto:ventas@millennials.pe"
              className="flex items-center text-primary-foreground hover:opacity-80 transition-smooth">

              <Icon name="Mail" size={20} className="mr-2" />
              <span className="text-sm md:text-base font-medium whitespace-nowrap">
                ventas@millennials.pe
              </span>
            </a>
          </div>
        </div>
      </div>
    </div>);

};

export default CompanyCredentials;